// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-Spinner-Spinner__spinner--3sqAP{width:44rem;text-align:center}.src-components-Spinner-Spinner__spinner--3sqAP>div{width:14rem;height:14rem;border-radius:100%;display:inline-block;animation:src-components-Spinner-Spinner__sk-bouncedelay--198hx 1.4s ease-in-out infinite both}.src-components-Spinner-Spinner__spinner--3sqAP .src-components-Spinner-Spinner__bounce1--3puA-{animation-delay:-.32s}.src-components-Spinner-Spinner__spinner--3sqAP .src-components-Spinner-Spinner__bounce2--3JzZa{animation-delay:-.16s}@keyframes src-components-Spinner-Spinner__sk-bouncedelay--198hx{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}", ""]);
// Exports
exports.locals = {
	"spinner": "src-components-Spinner-Spinner__spinner--3sqAP",
	"sk-bouncedelay": "src-components-Spinner-Spinner__sk-bouncedelay--198hx",
	"bounce1": "src-components-Spinner-Spinner__bounce1--3puA-",
	"bounce2": "src-components-Spinner-Spinner__bounce2--3JzZa"
};
module.exports = exports;
